import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";

function labelForItem(item) {
  const kode = item?.kode_barang || "-";
  const name = item?.nama_barang ? ` - ${item.nama_barang}` : "";
  return `${kode}${name}`;
}

export default function RequestDeleteModal({ item, reasonRef }) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (reasonRef) reasonRef.current = reason;
  }, [reason, reasonRef]);

  return (
    <div className="space-y-3">
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-sm text-amber-800">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-amber-200 bg-white text-amber-700">
            <Trash2 className="h-4 w-4" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-amber-950">Request penghapusan histori</div>
            <div className="mt-1 break-words">
              Produk: <span className="font-mono">{labelForItem(item)}</span>
            </div>
            <div>
              Qty: <span className="font-semibold">{item?.qty ?? "-"}</span>
            </div>
          </div>
        </div>
        <div className="mt-1 text-xs text-amber-700">Data tidak akan dihapus sebelum admin menyetujui request ini.</div>
      </div>

      <div>
        <label className="field-label">Alasan penghapusan</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="input min-h-24"
          placeholder="Contoh: double entry, transaksi batal, salah input, dll."
          autoFocus
        />
        <div className="field-help">Wajib diisi. Request akan masuk ke approval admin.</div>
      </div>
    </div>
  );
}
